{
  "three-acts": {
    "name": "Drie akten",
    "summary": "Introductie, confrontatie en ontknoping: de vorm die de meeste romans en films delen.",
    "bestFor": "Elk genre en een eerste versie die je eenvoudig wilt houden.",
    "metaTitle": "Verhaalsjabloon in drie akten — Musael",
    "metaDescription": "Introductie, confrontatie en ontknoping: de vorm van de meeste romans en films. Voor elk genre en een eenvoudige eerste versie.",
    "acts": [
      {
        "title": "Akte I: Introductie",
        "synopsis": "Wie de hoofdpersoon is, wat die wil en de gebeurtenis die het gewone leven beëindigt.",
        "chapters": [
          {
            "title": "De gewone wereld",
            "synopsis": "De hoofdpersoon thuis, met het verlangen en de zwakke plek die het verhaal op de proef stelt.",
            "scenes": [
              {
                "title": "Openingsbeeld",
                "synopsis": "Een momentopname van de hoofdpersoon voordat er iets verandert."
              },
              {
                "title": "De haak",
                "synopsis": "Iets kleins maar vreemds dat problemen aankondigt."
              }
            ]
          },
          {
            "title": "De aanzet",
            "synopsis": "De gebeurtenis die de hoofdpersoon niet kan negeren.",
            "scenes": [
              {
                "title": "Aanzet",
                "synopsis": "Het probleem dient zich aan en verdwijnt niet."
              },
              {
                "title": "Twijfel",
                "synopsis": "De hoofdpersoon aarzelt, en we zien wat er te verliezen valt."
              }
            ]
          },
          {
            "title": "De drempel over",
            "synopsis": "De hoofdpersoon verbindt zich aan de keuze; teruggaan is niet meer eenvoudig.",
            "scenes": [
              {
                "title": "De beslissing",
                "synopsis": "De hoofdpersoon besluit te handelen en laat het vertrouwde achter."
              }
            ]
          }
        ]
      },
      {
        "title": "Akte II: Confrontatie",
        "synopsis": "De hoofdpersoon probeert, faalt en leert, terwijl er steeds meer op het spel staat.",
        "chapters": [
          {
            "title": "De inzet stijgt",
            "synopsis": "Nieuwe regels, bondgenoten en vijanden; de eerste overwinningen hebben een prijs.",
            "scenes": [
              {
                "title": "Eerste beproeving",
                "synopsis": "De hoofdpersoon ontmoet de nieuwe wereld en begrijpt die deels verkeerd."
              },
              {
                "title": "Bondgenoten en vijanden",
                "synopsis": "Wie helpt, wie tegenwerkt en waarom."
              }
            ]
          },
          {
            "title": "Het middelpunt",
            "synopsis": "Een ommekeer die verandert waar het verhaal over gaat.",
            "scenes": [
              {
                "title": "Middelpunt",
                "synopsis": "Een schijnoverwinning of schijnnederlaag; de hoofdpersoon stopt met reageren en neemt het voortouw."
              }
            ]
          },
          {
            "title": "Alles valt uiteen",
            "synopsis": "De tegenstand neemt toe en de zwakke plek komt de hoofdpersoon duur te staan.",
            "scenes": [
              {
                "title": "De druk neemt toe",
                "synopsis": "Elk plan stuit op verzet; relaties vertonen scheuren."
              },
              {
                "title": "Alles is verloren",
                "synopsis": "Het dieptepunt: het doel lijkt voorgoed buiten bereik."
              }
            ]
          }
        ]
      },
      {
        "title": "Akte III: Ontknoping",
        "synopsis": "De hoofdpersoon verandert, doorstaat de laatste beproeving en een nieuw normaal begint.",
        "chapters": [
          {
            "title": "De climax",
            "synopsis": "De laatste confrontatie, gewonnen dankzij de les uit de tweede akte.",
            "scenes": [
              {
                "title": "Het laatste plan",
                "synopsis": "De hoofdpersoon brengt het geleerde samen en doet een laatste poging."
              },
              {
                "title": "Climax",
                "synopsis": "De beslissende confrontatie."
              }
            ]
          },
          {
            "title": "Het nieuwe normaal",
            "synopsis": "Wat er veranderd is, voor de hoofdpersoon en voor de wereld.",
            "scenes": [
              {
                "title": "Slotbeeld",
                "synopsis": "Een spiegel van het openingsbeeld die laat zien hoe ver de hoofdpersoon is gekomen."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "De reis van de held",
    "summary": "Twaalf fasen van de oproep tot avontuur tot de thuiskomst, verdeeld over vertrek, inwijding en terugkeer.",
    "bestFor": "Fantasy, avontuur en queesten.",
    "metaTitle": "Verhaalsjabloon voor de reis van de held — Musael",
    "metaDescription": "Twaalf fasen van de oproep tot avontuur tot thuiskomst: vertrek, inwijding en terugkeer. Voor fantasy, avontuur en queesten.",
    "acts": [
      {
        "title": "Vertrek",
        "synopsis": "De hoofdpersoon verlaat de bekende wereld.",
        "chapters": [
          {
            "title": "De gewone wereld",
            "synopsis": "De hoofdpersoon vóór het avontuur: thuis, gewoonten en wat er ontbreekt.",
            "scenes": [
              {
                "title": "De gewone wereld",
                "synopsis": "De hoofdpersoon vóór het avontuur: thuis, gewoonten en wat er ontbreekt."
              }
            ]
          },
          {
            "title": "De oproep tot avontuur",
            "synopsis": "Een uitdaging of bericht verstoort de gewone wereld.",
            "scenes": [
              {
                "title": "De oproep tot avontuur",
                "synopsis": "Een uitdaging of bericht verstoort de gewone wereld."
              }
            ]
          },
          {
            "title": "Weigering van de oproep",
            "synopsis": "Angst of plicht houdt de hoofdpersoon tegen.",
            "scenes": [
              {
                "title": "Weigering van de oproep",
                "synopsis": "Angst of plicht houdt de hoofdpersoon tegen."
              }
            ]
          },
          {
            "title": "Ontmoeting met de mentor",
            "synopsis": "Iemand geeft advies, training of een geschenk.",
            "scenes": [
              {
                "title": "Ontmoeting met de mentor",
                "synopsis": "Iemand geeft advies, training of een geschenk."
              }
            ]
          },
          {
            "title": "De eerste drempel over",
            "synopsis": "De hoofdpersoon betreedt de bijzondere wereld.",
            "scenes": [
              {
                "title": "De eerste drempel over",
                "synopsis": "De hoofdpersoon betreedt de bijzondere wereld."
              }
            ]
          }
        ]
      },
      {
        "title": "Inwijding",
        "synopsis": "Beproevingen in de bijzondere wereld en de grote krachtproef.",
        "chapters": [
          {
            "title": "Beproevingen, bondgenoten en vijanden",
            "synopsis": "De hoofdpersoon leert de regels van de nieuwe wereld.",
            "scenes": [
              {
                "title": "Beproevingen, bondgenoten en vijanden",
                "synopsis": "De hoofdpersoon leert de regels van de nieuwe wereld."
              }
            ]
          },
          {
            "title": "Nadering van de diepste grot",
            "synopsis": "Voorbereidingen op het centrale gevaar.",
            "scenes": [
              {
                "title": "Nadering van de diepste grot",
                "synopsis": "Voorbereidingen op het centrale gevaar."
              }
            ]
          },
          {
            "title": "De grote beproeving",
            "synopsis": "Een crisis op leven en dood; iets in de hoofdpersoon sterft.",
            "scenes": [
              {
                "title": "De grote beproeving",
                "synopsis": "Een crisis op leven en dood; iets in de hoofdpersoon sterft."
              }
            ]
          },
          {
            "title": "De beloning",
            "synopsis": "De hoofdpersoon bemachtigt de schat, kennis of verzoening.",
            "scenes": [
              {
                "title": "De beloning",
                "synopsis": "De hoofdpersoon bemachtigt de schat, kennis of verzoening."
              }
            ]
          }
        ]
      },
      {
        "title": "Terugkeer",
        "synopsis": "De weg naar huis, een laatste beproeving en wat de hoofdpersoon meebrengt.",
        "chapters": [
          {
            "title": "De terugweg",
            "synopsis": "De hoofdpersoon keert huiswaarts, vaak achtervolgd.",
            "scenes": [
              {
                "title": "De terugweg",
                "synopsis": "De hoofdpersoon keert huiswaarts, vaak achtervolgd."
              }
            ]
          },
          {
            "title": "Wederopstanding",
            "synopsis": "Een laatste beproeving waarin al het geleerde wordt gebruikt.",
            "scenes": [
              {
                "title": "Wederopstanding",
                "synopsis": "Een laatste beproeving waarin al het geleerde wordt gebruikt."
              }
            ]
          },
          {
            "title": "Terugkeer met het elixer",
            "synopsis": "De hoofdpersoon komt veranderd thuis, met iets om te delen.",
            "scenes": [
              {
                "title": "Terugkeer met het elixer",
                "synopsis": "De hoofdpersoon komt veranderd thuis, met iets om te delen."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Opzet in vijftien verhaalmomenten",
    "summary": "Het schema van scenarioschrijvers: vijftien keerpunten verdeeld over drie akten.",
    "bestFor": "Strakke, commerciële plots met duidelijke keerpunten.",
    "metaTitle": "Sjabloon met vijftien verhaalmomenten — Musael",
    "metaDescription": "Het schema van scenarioschrijvers: vijftien keerpunten in drie akten. Voor strakke, commerciële plots met duidelijke keerpunten.",
    "acts": [
      {
        "title": "Akte I",
        "synopsis": "De wereld van ervoor en de keuze om die te verlaten.",
        "chapters": [
          {
            "title": "Openingsbeeld",
            "synopsis": "De hoofdpersoon en de wereld vóór het verhaal.",
            "scenes": [
              {
                "title": "Openingsbeeld",
                "synopsis": "De hoofdpersoon en de wereld vóór het verhaal."
              }
            ]
          },
          {
            "title": "Het thema wordt benoemd",
            "synopsis": "Iemand zegt waar het verhaal echt over gaat; de hoofdpersoon ziet het nog niet.",
            "scenes": [
              {
                "title": "Het thema wordt benoemd",
                "synopsis": "Iemand zegt waar het verhaal echt over gaat; de hoofdpersoon ziet het nog niet."
              }
            ]
          },
          {
            "title": "Introductie",
            "synopsis": "Het leven van de hoofdpersoon, de mensen daarin en wat er moet veranderen.",
            "scenes": [
              {
                "title": "Introductie",
                "synopsis": "Het leven van de hoofdpersoon, de mensen daarin en wat er moet veranderen."
              }
            ]
          },
          {
            "title": "Katalysator",
            "synopsis": "De gebeurtenis die het verhaal in beweging zet.",
            "scenes": [
              {
                "title": "Katalysator",
                "synopsis": "De gebeurtenis die het verhaal in beweging zet."
              }
            ]
          },
          {
            "title": "Twijfel",
            "synopsis": "De hoofdpersoon twijfelt over wat te doen.",
            "scenes": [
              {
                "title": "Twijfel",
                "synopsis": "De hoofdpersoon twijfelt over wat te doen."
              }
            ]
          },
          {
            "title": "Overgang naar de tweede akte",
            "synopsis": "De hoofdpersoon kiest een nieuwe weg.",
            "scenes": [
              {
                "title": "Overgang naar de tweede akte",
                "synopsis": "De hoofdpersoon kiest een nieuwe weg."
              }
            ]
          }
        ]
      },
      {
        "title": "Akte II",
        "synopsis": "De belofte van de premisse, gevolgd door de val.",
        "chapters": [
          {
            "title": "Nevenverhaal",
            "synopsis": "Een tweede verhaal, vaak een relatie, dat het thema draagt.",
            "scenes": [
              {
                "title": "Nevenverhaal",
                "synopsis": "Een tweede verhaal, vaak een relatie, dat het thema draagt."
              }
            ]
          },
          {
            "title": "Spel en plezier",
            "synopsis": "De premisse wordt waargemaakt: waarvoor de lezers kwamen.",
            "scenes": [
              {
                "title": "Spel en plezier",
                "synopsis": "De premisse wordt waargemaakt: waarvoor de lezers kwamen."
              }
            ]
          },
          {
            "title": "Middelpunt",
            "synopsis": "Een schijnoverwinning of -nederlaag verhoogt de inzet.",
            "scenes": [
              {
                "title": "Middelpunt",
                "synopsis": "Een schijnoverwinning of -nederlaag verhoogt de inzet."
              }
            ]
          },
          {
            "title": "De tegenstanders komen dichterbij",
            "synopsis": "Twijfel vanbinnen, druk vanbuiten.",
            "scenes": [
              {
                "title": "De tegenstanders komen dichterbij",
                "synopsis": "Twijfel vanbinnen, druk vanbuiten."
              }
            ]
          },
          {
            "title": "Alles is verloren",
            "synopsis": "Het tegenovergestelde van het middelpunt: het diepste dal.",
            "scenes": [
              {
                "title": "Alles is verloren",
                "synopsis": "Het tegenovergestelde van het middelpunt: het diepste dal."
              }
            ]
          },
          {
            "title": "De donkere nacht van de ziel",
            "synopsis": "De hoofdpersoon rouwt om het verlies en ontdekt de les.",
            "scenes": [
              {
                "title": "De donkere nacht van de ziel",
                "synopsis": "De hoofdpersoon rouwt om het verlies en ontdekt de les."
              }
            ]
          }
        ]
      },
      {
        "title": "Akte III",
        "synopsis": "De les wordt toegepast.",
        "chapters": [
          {
            "title": "Overgang naar de derde akte",
            "synopsis": "Een nieuw idee uit het nevenverhaal opent een weg.",
            "scenes": [
              {
                "title": "Overgang naar de derde akte",
                "synopsis": "Een nieuw idee uit het nevenverhaal opent een weg."
              }
            ]
          },
          {
            "title": "Finale",
            "synopsis": "De hoofdpersoon herstelt wat kapot was en is voorgoed veranderd.",
            "scenes": [
              {
                "title": "Finale",
                "synopsis": "De hoofdpersoon herstelt wat kapot was en is voorgoed veranderd."
              }
            ]
          },
          {
            "title": "Eindbeeld",
            "synopsis": "De wereld erna, als spiegel van het openingsbeeld.",
            "scenes": [
              {
                "title": "Eindbeeld",
                "synopsis": "De wereld erna, als spiegel van het openingsbeeld."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Zevenpuntenstructuur",
    "summary": "Plan terug vanaf het einde: haak, wendingen, drukpunten, middelpunt en ontknoping.",
    "bestFor": "Schrijvers die eerst het einde kennen.",
    "metaTitle": "Verhaalsjabloon met zeven punten — Musael",
    "metaDescription": "Plan terug vanaf het einde: haak, wendingen, drukpunten, middelpunt en ontknoping. Voor schrijvers die eerst het einde kennen.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Haak",
            "synopsis": "De beginsituatie, het tegenovergestelde van de ontknoping.",
            "scenes": [
              {
                "title": "Haak",
                "synopsis": "De beginsituatie, het tegenovergestelde van de ontknoping."
              }
            ]
          },
          {
            "title": "Plotwending 1",
            "synopsis": "Het conflict begint en dwingt de hoofdpersoon tot handelen.",
            "scenes": [
              {
                "title": "Plotwending 1",
                "synopsis": "Het conflict begint en dwingt de hoofdpersoon tot handelen."
              }
            ]
          },
          {
            "title": "Drukpunt 1",
            "synopsis": "De tegenstander zet druk; de hoofdpersoon moet handelen.",
            "scenes": [
              {
                "title": "Drukpunt 1",
                "synopsis": "De tegenstander zet druk; de hoofdpersoon moet handelen."
              }
            ]
          },
          {
            "title": "Middelpunt",
            "synopsis": "De hoofdpersoon gaat van reageren naar handelen.",
            "scenes": [
              {
                "title": "Middelpunt",
                "synopsis": "De hoofdpersoon gaat van reageren naar handelen."
              }
            ]
          },
          {
            "title": "Drukpunt 2",
            "synopsis": "Het gaat grondig mis; het plan mislukt.",
            "scenes": [
              {
                "title": "Drukpunt 2",
                "synopsis": "Het gaat grondig mis; het plan mislukt."
              }
            ]
          },
          {
            "title": "Plotwending 2",
            "synopsis": "De hoofdpersoon krijgt het laatste ontbrekende stuk om te winnen.",
            "scenes": [
              {
                "title": "Plotwending 2",
                "synopsis": "De hoofdpersoon krijgt het laatste ontbrekende stuk om te winnen."
              }
            ]
          },
          {
            "title": "Ontknoping",
            "synopsis": "De eindsituatie, het antwoord op de haak.",
            "scenes": [
              {
                "title": "Ontknoping",
                "synopsis": "De eindsituatie, het antwoord op de haak."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Vier bewegingen die draaien om een wending in plaats van een conflict.",
    "bestFor": "Literaire fictie, korte verhalen en rustige, personagegedreven boeken.",
    "metaTitle": "Verhaalsjabloon Kishōtenketsu — Musael",
    "metaDescription": "Vier bewegingen rond een wending in plaats van een conflict. Voor literaire fictie, korte verhalen en rustige, personagegedreven boeken.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: introductie",
            "synopsis": "De personages en hun wereld, rustig voorgesteld.",
            "scenes": [
              {
                "title": "Introductie",
                "synopsis": "Wie, waar en hoe het gewone leven eruitziet."
              }
            ]
          },
          {
            "title": "Shō: ontwikkeling",
            "synopsis": "De situatie verdiept zich, nog zonder wending.",
            "scenes": [
              {
                "title": "Ontwikkeling",
                "synopsis": "We leren de personages beter kennen; kleine dingen verschuiven."
              }
            ]
          },
          {
            "title": "Ten: wending",
            "synopsis": "Een onverwacht element verandert hoe we naar alles kijken.",
            "scenes": [
              {
                "title": "De wending",
                "synopsis": "Er komt iets nieuws bij, schijnbaar zonder verband."
              }
            ]
          },
          {
            "title": "Ketsu: samenkomst",
            "synopsis": "De delen komen samen in een nieuw inzicht.",
            "scenes": [
              {
                "title": "Samenkomst",
                "synopsis": "De wending en het verhaal ontmoeten elkaar; de betekenis verschuift."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Mysterie",
    "summary": "Een misdaad, een onderzoek met aanwijzingen en dwaalsporen en een eerlijke onthulling.",
    "bestFor": "Misdaadverhalen, detectives en cosy mysteries.",
    "metaTitle": "Verhaalsjabloon voor mysteries — Musael",
    "metaDescription": "Een misdaad, aanwijzingen, dwaalsporen en een eerlijke onthulling. Voor misdaadverhalen, detectives en cosy mysteries.",
    "acts": [
      {
        "title": "De misdaad",
        "synopsis": "Er klopt iets niet, en iemand moet uitzoeken waarom.",
        "chapters": [
          {
            "title": "De ontdekking",
            "synopsis": "De misdaad of de verdwijning.",
            "scenes": [
              {
                "title": "Het lichaam",
                "synopsis": "De misdaad wordt ontdekt; eerste indrukken en eerste vragen."
              },
              {
                "title": "De speurder",
                "synopsis": "Wie onderzoek doet en waarom de zaak voor die persoon belangrijk is."
              }
            ]
          }
        ]
      },
      {
        "title": "Het onderzoek",
        "synopsis": "Aanwijzingen, verdachten en dwaalsporen.",
        "chapters": [
          {
            "title": "Verdachten",
            "synopsis": "Iedereen met een motief en een alibi.",
            "scenes": [
              {
                "title": "Gesprekken",
                "synopsis": "Elke verdachte krijgt een reden om te liegen."
              },
              {
                "title": "De eerste aanwijzing",
                "synopsis": "Een feit dat later belangrijk wordt; speel eerlijk met de lezer."
              }
            ]
          },
          {
            "title": "Dwaalsporen",
            "synopsis": "Het onderzoek gaat de verkeerde kant op.",
            "scenes": [
              {
                "title": "Een dwaalspoor",
                "synopsis": "Het bewijs wijst naar de verkeerde persoon."
              },
              {
                "title": "Escalatie",
                "synopsis": "Een tweede misdaad of een bedreiging verhoogt de inzet."
              }
            ]
          },
          {
            "title": "De verborgen waarheid",
            "synopsis": "De speurder ziet wat er altijd al was.",
            "scenes": [
              {
                "title": "Het ontbrekende stukje",
                "synopsis": "Een klein detail laat de eerdere aanwijzingen op hun plaats vallen."
              }
            ]
          }
        ]
      },
      {
        "title": "De onthulling",
        "synopsis": "De oplossing en de prijs ervan.",
        "chapters": [
          {
            "title": "De oplossing",
            "synopsis": "Elke aanwijzing wordt verklaard.",
            "scenes": [
              {
                "title": "De onthulling",
                "synopsis": "De dader wordt genoemd en de redenering uiteengezet."
              },
              {
                "title": "De nasleep",
                "synopsis": "Gerechtigheid, of het ontbreken daarvan, en wat de speurder overhoudt."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romantiek",
    "summary": "Twee mensen, wat hen uit elkaar houdt en wat nodig is om voor elkaar te kiezen.",
    "bestFor": "Romantische fictie en liefdesverhalen in elke setting.",
    "metaTitle": "Verhaalsjabloon voor romantiek — Musael",
    "metaDescription": "Twee mensen, wat hen scheidt en wat nodig is om voor elkaar te kiezen. Voor romantische fictie en liefdesverhalen in elke setting.",
    "acts": [
      {
        "title": "Verliefd worden",
        "synopsis": "Ze ontmoeten elkaar, verzetten zich en beginnen verliefd te worden.",
        "chapters": [
          {
            "title": "De ontmoeting",
            "synopsis": "De eerste ontmoeting, met de vonk en het obstakel.",
            "scenes": [
              {
                "title": "Ontmoeting",
                "synopsis": "De twee hoofdpersonen ontmoeten elkaar; iets aan de ander raakt hen diep."
              },
              {
                "title": "Weerstand",
                "synopsis": "Waarom dit niet kan werken: doelen, wonden of omstandigheden."
              }
            ]
          },
          {
            "title": "Naar elkaar toegroeien",
            "synopsis": "Gedwongen tot samenzijn, zien ze elkaar zoals ze werkelijk zijn.",
            "scenes": [
              {
                "title": "Toevallig samen",
                "synopsis": "Een situatie houdt hen dicht bij elkaar."
              },
              {
                "title": "Het eerste echte moment",
                "synopsis": "Een glimp van wie de ander werkelijk is."
              }
            ]
          }
        ]
      },
      {
        "title": "Twijfelen",
        "synopsis": "Toewijding, gevolgd door de angst die haar breekt.",
        "chapters": [
          {
            "title": "Het middelpunt",
            "synopsis": "Ze geven toe aan hun gevoelens.",
            "scenes": [
              {
                "title": "Toewijding",
                "synopsis": "Een kus, een bekentenis of een belofte."
              }
            ]
          },
          {
            "title": "De breuk",
            "synopsis": "De oude wond of het obstakel van buitenaf wint, voorlopig.",
            "scenes": [
              {
                "title": "Twijfel",
                "synopsis": "Oude angsten keren terug."
              },
              {
                "title": "De scheiding",
                "synopsis": "Ze gaan uiteen, allebei overtuigd van hun gelijk."
              }
            ]
          }
        ]
      },
      {
        "title": "Kiezen",
        "synopsis": "Groei, een groot gebaar en een gedeelde toekomst.",
        "chapters": [
          {
            "title": "Samen",
            "synopsis": "Beiden veranderen genoeg om de ander te verdienen.",
            "scenes": [
              {
                "title": "Het grote gebaar",
                "synopsis": "Een van hen riskeert alles om te laten zien dat die veranderd is."
              },
              {
                "title": "Nog lang en gelukkig",
                "synopsis": "Of voorlopig gelukkig: de toekomst waarvoor ze kiezen."
              }
            ]
          }
        ]
      }
    ]
  }
}
